import {$qs, $qsAll} from '../../../@shared/ts/dom';
import {type IResponse} from '../../../@type/response';

declare const peachpay_admin: PeachPayAdminData;

function handleStripeCaptureVoidForm() {
	const $orderInput = $qs<HTMLInputElement>('#pp-stripe-actions input[name="order_id"]');
	const $amountInput = $qs<HTMLInputElement>('#pp-stripe-actions input[name="amount"]');
	const $captureButton = $qs('#pp-stripe-actions button[name="capture"]');
	const $voidButton = $qs('#pp-stripe-actions button[name="void"]');
	const $error = $qs('.error-message');

	if (!$amountInput || !$orderInput || !$captureButton || !$voidButton || !$error) {
		return;
	}

	const disableForm = () => $qsAll('#pp-stripe-actions input, #pp-stripe-actions button', $e => {
		$e.setAttribute('disabled', 'true');
	});
	const enableForm = () => $qsAll('#pp-stripe-actions input, #pp-stripe-actions button', $e => {
		$e.removeAttribute('disabled');
	});
	const clearStatus = () => {
		$error.innerHTML = '';
	};

	const setStatus = (errorMessage: string) => {
		$error.innerHTML = errorMessage;
	};

	$captureButton.addEventListener('click', async e => {
		e.preventDefault();

		if (!$amountInput.checkValidity()) {
			$amountInput.reportValidity();
			return;
		}

		clearStatus();
		disableForm();

		const orderId = $orderInput.value;
		const amountToCapture = $amountInput.value;

		const formData = new FormData();
		formData.append('action', 'pp-stripe-capture-payment');
		formData.append('security', peachpay_admin.nonces.stripe_capture_payment);
		formData.append('order_id', orderId);
		formData.append('amount_to_capture', amountToCapture);

		const response = await fetch(peachpay_admin.admin_ajax, {
			method: 'POST',
			body: formData,
		});

		const data = await response.json() as IResponse<void>;

		if (!data.success) {
			enableForm();
			setStatus(data.message ?? '');
			return;
		}

		location.reload();
	});

	$voidButton.addEventListener('click', async (e: Event) => {
		e.preventDefault();

		clearStatus();
		disableForm();

		const orderId = $orderInput.value;

		const formData = new FormData();
		formData.append('action', 'pp-stripe-void-payment');
		formData.append('security', peachpay_admin.nonces.stripe_void_payment);
		formData.append('order_id', orderId);

		const response = await fetch(peachpay_admin.admin_ajax, {
			method: 'POST',
			body: formData,
		});

		const data = await response.json() as IResponse<void>;

		if (!data.success) {
			enableForm();
			setStatus(data.message ?? '');
			return;
		}

		location.reload();
	});
}

export {handleStripeCaptureVoidForm};
